import "./Button.css";

/**
 * Shared CTA button. Renders an <a> when `href` is given, a <button> otherwise.
 * variant: "solid" (default) | "outline"
 */
function Button({ href, children, variant = "solid", ...rest }) {
  const className = `Button Button--${variant}`;

  if (href) {
    return (
      <a
        href={href}
        className={className}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={className} {...rest}>
      {children}
    </button>
  );
}

export default Button;
